/** Learner home — design testing page. */
import { CoachCard } from '../home/cards/revise';

export default function DesignTestingPage() {
  return (
    <div
      className="relative mx-auto w-full px-6 pb-24"
      style={{ fontFamily: 'var(--font-sans)', maxWidth: 'var(--page-max-width)' }}
    >
      <section className="pt-14">
        <h1
          className="font-semibold"
          style={{
            fontSize: 32,
            color: 'var(--color-text)',
            letterSpacing: '-0.02em',
          }}
        >
          Design Testing
        </h1>
        <p style={{ fontSize: 16, color: 'var(--color-text-muted)', marginTop: 8 }}>
          CoachCard — learning-status widget mockup. Natural height on the left, a tall container on
          the right so you can see how the card expands when a sibling column stretches it.
        </p>
      </section>

      {/* Two canvases side-by-side: natural height vs forced-tall. Lets us see
          what a filled-out column looks like without actually rendering the
          sibling content. */}
      <section
        style={{
          marginTop: 32,
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(360px, 420px))',
          gap: 32,
          justifyContent: 'center',
          alignItems: 'start',
        }}
      >
        {/* Natural height — card auto-sizes to content. */}
        <div>
          <div
            style={{
              ...eyebrowStyle,
              marginBottom: 8,
            }}
          >
            Natural height
          </div>
          <CoachCard />
        </div>

        {/* Tall container — forces the card to stretch. Useful for seeing
            how the flex:1 spacer behaves and where empty space lands. */}
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              ...eyebrowStyle,
              marginBottom: 8,
            }}
          >
            Tall column (700px)
          </div>
          <div style={{ height: 700 }}>
            <CoachCard />
          </div>
        </div>
      </section>
    </div>
  );
}

const eyebrowStyle: React.CSSProperties = {
  fontSize: 11,
  fontWeight: 600,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  color: 'var(--color-text-muted)',
};
